import { useState } from "react";
import { toast } from "sonner";
import { FileBadge, UserX } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { downloadFile } from "../common/DataActions";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function HeadmasterActions({ card, reload, onClose }) {
  const { user } = useAuth();
  const [doOpen, setDoOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  if (!["academic_admin", "super_admin"].includes(user.role)) return null;
  const dropOut = async () => {
    if (!reason.trim()) return toast.error("Alasan DO wajib diisi");
    if (!window.confirm(`Keluarkan ${card.name} dari Yutaka? Siswa akan dihapus dari rombel, jadwal, kanban & penilaian. Data arsip tetap tersimpan di menu Siswa DO.`)) return;
    setBusy(true);
    try { await api.post(`/students/${card.id}/dropout`, { reason, notes }); toast.success(`${card.name} telah di-Drop Out`); reload(); onClose(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const issueCert = async () => {
    if (!window.confirm(`Terbitkan Sertifikat Sementara untuk ${card.name}?\n\nHasil belajar aktual (BELUM LENGKAP) akan dicetak, nomor SKS dibuat, dan siswa OTOMATIS berpindah ke Alumni (keluar dari rombel/kanban).`)) return;
    setBusy(true);
    try {
      const res = await api.post(`/students/${card.id}/progress-certificate/issue`, {}, { responseType: "blob" });
      const url = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = url; a.download = `sertifikat_sementara_${card.name}.pdf`; a.click(); URL.revokeObjectURL(url);
      toast.success(`${card.name} → Alumni (sertifikat sementara terbit)`); reload(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 pt-3 border-t" data-testid="headmaster-actions">
      <p className="caption">Kepala Sekolah</p>
      <div className="grid grid-cols-2 gap-2">
        <Button data-testid="progress-cert-button" className="bg-[color:var(--brand-blue)] hover:bg-[color:var(--brand-blue-dark)]" disabled={busy} onClick={issueCert}><FileBadge className="h-4 w-4 mr-1" />Terbitkan Sertifikat</Button>
        <Button data-testid="dropout-button" variant="outline" className="border-red-300 text-red-700 hover:bg-red-50" onClick={() => setDoOpen((v) => !v)}><UserX className="h-4 w-4 mr-1" />Drop Out (DO)</Button>
      </div>
      <p className="text-[11px] text-slate-500">Sertifikat sementara = hasil belajar aktual sampai hari ini (ditandai <b>BELUM LENGKAP</b>). Saat diterbitkan, siswa <b>otomatis menjadi Alumni</b>. <button type="button" data-testid="progress-cert-preview" className="underline text-sky-700" onClick={() => downloadFile(`/students/${card.id}/progress-certificate.pdf`, `pratinjau_${card.name}.pdf`)}>Pratinjau PDF</button> tanpa mengubah status.</p>
      {doOpen && <div className="rounded-md border border-red-200 bg-red-50/60 p-3 space-y-2" data-testid="dropout-form">
        <Input data-testid="dropout-reason-input" placeholder="Alasan DO (wajib) — mis. mengundurkan diri, pelanggaran berat" value={reason} onChange={(e) => setReason(e.target.value)} />
        <Input data-testid="dropout-notes-input" placeholder="Catatan tambahan (opsional)" value={notes} onChange={(e) => setNotes(e.target.value)} />
        <Button data-testid="dropout-submit-button" className="w-full bg-red-600 hover:bg-red-700" disabled={busy || !reason.trim()} onClick={dropOut}><UserX className="h-4 w-4 mr-1" />Konfirmasi Drop Out</Button>
      </div>}
    </div>
  );
}
